import moment from 'moment'

export function formatDate (date, fmt = 'MMMM DD hh:mm a') {
  return moment(date).format(fmt)
}

export function humanizeDate (date) {
  return moment(date).calendar(null, {
    lastWeek: 'DD MMM LT',
    sameElse: 'DD MMM LT'
  })
}

export function humanizeFutureDate (date) {
  return moment(date).calendar(null, {
    sameDay: '[today at] HH:mm',
    nextDay: '[tomorrow at] HH:mm',
    sameElse: 'DD/MM/YYYY'
  }
 )
}



// WEBPACK FOOTER //
// ./src/js/utils/dates.util.js